export function initializeI18n(coreLocalizationService: unknown): () => Promise<unknown> {
  return (): Promise<unknown> => {
    return new Promise((resolve, reject) => {
      if (
        coreLocalizationService &&
        typeof coreLocalizationService === 'object' &&
        'onLangChanged' in coreLocalizationService
      ) {
        (coreLocalizationService as any).onLangChanged.subscribe({
          next: (success: unknown) => {
            resolve(success);
          },
          error: (error: unknown) => {
            reject(error);
          },
        });
      } else {
        resolve(null);
      }
    });
  };
}

export function initializeMenu(menuService: unknown): () => Promise<unknown> {
  return (): Promise<unknown> => {
    return new Promise((resolve, reject) => {
      if (
        menuService &&
        typeof menuService === 'object' &&
        'getAllMenu' in menuService &&
        typeof (menuService as any).getAllMenu === 'function'
      ) {
        (menuService as any).getAllMenu().subscribe({
          next: (menu: unknown) => {
            resolve(menu);
          },
          error: (error: unknown) => {
            reject(error);
          },
        });
      } else {
        resolve(null);
      }
    });
  };
}
